export default [
  {
    id: 1,
    question: 'What is an ATS and why do I need one?',
    answer: `The ATS enables your generator to switch on automatically, 
    meaning you don’t have to worry about flicking a switch. 
    It constantly monitors the utility power and as soon as the power fails it automatically 
    turns your generator on. When the power is restored it switches the generator back 
    to standby mode.`,
  },
  {
    id: 2,
    question: 'How much does installation cost? And where do I find an installer?',
    answer: `A home standby generator plus installation starts around $7,000, however every installation is unique depending on size of generator, 
    local codes and standards, and site specific requirements. Your local Cummins Dealer will tailor the estimate based on your needs. 
    <a href="https://homegenerators.cummins.com/free-home-assessment" target="_blank">Contact us to schedule a free, </a>
    no obligation in-home assessment to determine which generator is right for you or 
    <a href="https://www.cummins.com/na/generators/residential/find-a-dealer" target="_blank">locate your nearest Dealer</a>.
    *Generators must be installed by a qualified professional.`,
  },
  {
    id: 3,
    question: 'What is remote operation?',
    answer: `Cummins Connect Cloud delivers the ability to control your generator 
    from anywhere via a mobile app or desktop portal.`,
  },
  {
    id: 4,
    question: 'What is No-start exercise?',
    answer: `No-start exercise means your generator can exercise itself for just 30 seconds 
    instead of 20 minutes like standard models, meaning less noise, 
    less emissions and less fuel used.`,
  },
  {
    id: 5,
    question: 'What is Intelligent Load Management?',
    answer: `Intelligent load management means you can sit back while your generator 
    intelligently controls the loads for you.`,
  },
];



// WEBPACK FOOTER //
// ./src/views/Home/components/FAQs/data/q-and-a.js